import React from 'react';
import LeftTrainingLogin from './Components/LeftTrainingLogin';
import '../../style.css';

const LeftBlock = (props) =>
{
	const { joinDetails } = props;

	return (
		<div className='flexRow fullHeight'>
			<LeftTrainingLogin joinDetails={joinDetails} />
		</div>
	);
};

export default LeftBlock;
